import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface CurrencyRateProps {}

const CurrencyRate: FC<CurrencyRateProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'currencyRate'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default CurrencyRate
